import React from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';

import Section from '@spotahome/ui-library/lib/components/Section';

import Hero from '../../common/components/Hero';
import HeaderContainer from '../../common/components/HeaderContainer';
import Footer from '../../common/components/Footer';
import Cookies from '../../common/components/Cookies';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';
import AppBanner from '../../common/components/AppBanner';

import CardsImages from './components/CardsImages';
import Apply from './components/Apply';
import Testimonials from './components/Testimonials';
import Features from './components/Features';
import Benefits from './components/Benefits';
import Video from './components/Video';

// Styles
import './../../common/scss/init.scss';

const CALL_TO_ACTION_URL = 'https://spotahome897.typeform.com/to/kaHkKX';

const HomeCheckerContainer = () => (
  <div>
    <Hero
      menu={
        <HeaderContainer
          options={['list-your-property', 'favorites']}
          tracking="ga-how-it-works"
        />
      }
      title={trans('home_checker.alt.hero.title')}
      subtitle={trans('home_checker.alt.hero.subtitle')}
      backgroundImage={`url(${getResourcePath(
        '/images/home-checker/home-checker-header.jpg'
      )})`}
      callToActionText="hero.apply-now"
      callToActionPath={CALL_TO_ACTION_URL}
    />

    <Section background="light">
      <Benefits />
    </Section>

    <Section>
      <Video />
    </Section>

    <Section background="light">
      <CardsImages />
    </Section>

    <Section>
      <Features />
    </Section>

    <Section background="light">
      <Testimonials />
    </Section>

    <Section>
      <Apply />
    </Section>

    <Footer />
    <SessionExpiredModal />
    <Cookies />
    <AppBanner />
  </div>
);

export default HomeCheckerContainer;
